// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SupportView_userProfile__K287I {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SupportView_title__18KZj {
  margin-top: 40px;
  margin-bottom: 20px;
}

.SupportView_input__SxM\\+F {
  min-width: 220px;
}
.SupportView_input__SxM\\+F input {
  min-width: 160px;
}

.SupportView_button__IHYpJ {
  min-width: 220px;
}

.SupportView_buttonContainer__\\+3Pwo {
  padding-top: 20px;
}

.SupportView_textarea__JmpwK {
  width: 100%;
  border: none;
  outline: none;
  resize: vertical;
}`, "",{"version":3,"sources":["webpack://./src/app/views/SupportView/SupportView.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAHF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_media';\n\n.userProfile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.title {\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n\n.input {\n  min-width: 220px;\n\n  input {\n    min-width: 160px;\n  }\n}\n\n.button {\n  min-width: 220px;\n}\n\n.buttonContainer {\n  padding-top: 20px;\n}\n\n.textarea {\n  width: 100%;\n  border: none;\n  outline: none;\n  resize: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userProfile": `SupportView_userProfile__K287I`,
	"title": `SupportView_title__18KZj`,
	"input": `SupportView_input__SxM+F`,
	"button": `SupportView_button__IHYpJ`,
	"buttonContainer": `SupportView_buttonContainer__+3Pwo`,
	"textarea": `SupportView_textarea__JmpwK`
};
export default ___CSS_LOADER_EXPORT___;
